import React, { Component, Fragment } from "react";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            user: {},
            unidades: [
                {
                    nome: "Centro de Formação Profissional Prof. Stenio Lopes",
                    nomeCRM: "CEP PROF. STÊNIO LOPES",
                    sigla: "SL",
                    path: "/sl"
                },
                {
                    nome: "Centro de Formação Profissional Odilon Ribeiro Coutinho",
                    nomeCRM: "CEP ODILON RIBEIRO COUTINHO",
                    sigla: "ORC",
                    path: "/orc"
                },
                {
                    nome: "Centro de Formação Profissional José William Lemos Leal",
                    nomeCRM: "CEP JOSÉ WILLIAM LEMOS LEAL",
                    sigla: "JWLL",
                    path: "/jwll"
                },
                {
                    nome: "CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL",
                    nomeCRM: "CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL",
                    sigla: "CITI/CAM",
                    path: "/cam"
                },
                {
                    nome: "Centro de Formação Profissional e Instituto SENAI de Tecnologia do Couro e do Calçado Albano Franco",
                    nomeCRM: "CTCC ALBANO FRANCO",
                    sigla: "CTCC",
                    path: "/ctcc"
                },
                {
                    nome: "Centro de Formação Profissional Miriam Benevides Gadelha",
                    nomeCRM: "CFP MIRIAM BENEVIDES GADELHA",
                    sigla: "MBG",
                    path: "/mbg"
                },
                /* ISTAI fica de fora — decisão do usuário (2026-08-24), ver docs/PLANO_ITEM8_CONSTANTES.md
                {
                    nome: "IST Automação Industrial",
                    nomeCRM: "IST AUTOMAÇÃO INDUSTRIAL",
                    sigla: "ISTAI",
                    path: "/istai"
                },
                */
                {
                    nome: "IST Têxtil e Confecções",
                    nomeCRM: "IST TÊXTIL E CONFECÇÕES",
                    sigla: "ISTTC",
                    path: "/isttc"
                },
                {
                    nome: "IST Eficiência Operacional",
                    nomeCRM: "IST EFICIÊNCIA OPERACIONAL",
                    sigla: "ISTEO",
                    path: "/isteo"
                },
                {
                    nome: "Robson Braga de Andrade",
                    nomeCRM: "ROBSON BRAGA DE ANDRADE",
                    sigla: "RBA",
                    path: "/rba"
                },
                {
                    nome: "Faculdade SENAI",
                    nomeCRM: "FACULDADE SENAI",
                    sigla: "FACULDADE",
                    path: "/faculdade"
                }
            ]
        }
    }

    verificaUnidade = (unidade) => {

        const user = JSON.parse(localStorage.getItem('user'));
        let unidadeUser = user.hasOwnProperty("unidade") && user.unidade;

        if(unidadeUser === unidade.nomeCRM || user.roles.indexOf("ROLE_ADMIN") > -1 || unidadeUser.split(',').includes(unidade.nomeCRM))  {
            return (
                <a href={"/unidade" + unidade.path}><button type="button" className="btn btn-primary btn-block">{unidade.sigla}</button></a>
            )
        }
        else {
            return (
                <button type="button" className="btn btn-primary btn-block" onClick={this.onClick}>{unidade.sigla}</button>
            )
        }

    }

    onClick = (event) => {
        event.preventDefault();
        window.showNotification('Você não tem permissão para acessar essa unidade!', 'warning');
    }

    render() {
        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="places-buttons">
                                        <div className="row">
                                            <div className="col-md-6 ml-auto mr-auto text-center">
                                                <h4 className="card-title"> Unidades
                                                    <p className="category">Escolha uma unidade</p>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 ml-auto mr-auto">
                                                <div className="row">
                                                    {this.state.unidades.map((unidade, key) => {
                                                        return (
                                                            <div key={key} className="col-md-4">
                                                                {this.verificaUnidade(unidade)}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}